import React from 'react'
import ReservationBuilderSegmentSummary from '../../ReservationBuilder/ReservationBuilderSegmentSummary'
import FoliosSelect from '../../Selects/FoliosSelect'
import ReservationSegmentBuilderErrors from '../ReservationSegmentBuilder'
//import I18n from "i18n-js/index.js.erb"

export default class ReservationSegmentBuilderConfirmAndUpdate extends React.Component {
  constructor(props) {
    super(props)
  }


  render() {
    // console.log("this.props.reservation_segment", this.props.reservation_segment );
    return(
      <div className="reservation-builder">
        {this.renderErrors()}
        <div className="confirm-finish">
          <div className="row">
            <div className="col-md-6">
              <div className="summary-of-charges">
                <h4>{I18n.t('summary_of_charges')}</h4>
                <div className="segments">
                  <ReservationBuilderSegmentSummary open={true} key={this.props.reservation_segment.temp_id || this.props.reservation_segment.id} segment={this.props.reservation_segment} edit_segment={this.props.edit_segment} date_format={this.props.date_format} />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-3">
                </div>
                <div className="col-md-9">
                  {this.renderFolioSelect()}
                </div>
              </div>
              <br />
              {/* {this.props.pay_now ? <ReservationSegmentBuilderPaymentDetails {...this.props} /> : null } */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderFolioSelect() {
    return(
      <div>
        {/* <div className="col-md-4"> */}
          <label>{I18n.t('select_folio')}</label>
          <FoliosSelect folio={this.props.folio ? this.props.folio : null} reservation_segment_id={this.props.reservation_segment.id} onChange={this.props.onChangeFolio} />
        {/* </div> */}
      </div>
    );
  };

  renderErrors() {
    // var errors = ReservationSegmentBuilderErrors.general(this.props.errors);
    var err = [];

    if (this.props.errors && this.props.errors.length) {
      for (var i = 0, ilen = this.props.errors.length; i < ilen; i++) {
        err.push(this.props.errors[i]);
      }
    }

    var errors = err

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  // renderChargeInstructions() {
  //   return(
  //     <div>
  //       <label>{I18n.t("pay_now")}</label>
  //       <Switch defaultValue={this.props.pay_now} onChange={this.props.onChangePayNow ? this.props.onChangePayNow : this.onChangePayNow} />
  //     </div>
  //   );
  // };


};
